import { render, staticRenderFns } from "./SuspendView.vue?vue&type=template&id=1128f3fb&scoped=true"
import script from "./SuspendView.vue?vue&type=script&lang=js"
export * from "./SuspendView.vue?vue&type=script&lang=js"
import style0 from "./SuspendView.vue?vue&type=style&index=0&id=1128f3fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1128f3fb",
  null
  
)

export default component.exports